module.exports = __webpack_public_path__ + "img/bg_selection1.3e264e40.png";